import React from 'react';
import { motion } from 'framer-motion';
import { HeartPulseIcon, ActivityIcon, StethoscopeIcon, PillIcon, PlusIcon, XIcon } from 'lucide-react';
type Specialty = 'cardiologist' | 'nephrologist' | 'gp' | 'endocrinologist';
interface SpecialtyToggleProps {
  visibleSpecialties: string[];
  onToggleSpecialty: (specialty: string) => void;
  selectedSpecialty: Specialty;
}
const ALL_SPECIALTIES: {
  key: string;
  label: string;
  color: string;
  icon: React.ElementType;
}[] = [{
  key: 'Cardiologist',
  label: 'Cardio',
  color: '#E11D48',
  icon: HeartPulseIcon
}, {
  key: 'Nephrologist',
  label: 'Nephro',
  color: '#0D9488',
  icon: ActivityIcon
}, {
  key: 'GP',
  label: 'GP',
  color: '#6366F1',
  icon: StethoscopeIcon
}, {
  key: 'Endocrinologist',
  label: 'Endo',
  color: '#F59E0B',
  icon: PillIcon
}];
function specialtyToKey(s: Specialty): string {
  if (s === 'gp') return 'GP';
  return s.charAt(0).toUpperCase() + s.slice(1);
}
export function SpecialtyToggle({
  visibleSpecialties,
  onToggleSpecialty,
  selectedSpecialty
}: SpecialtyToggleProps) {
  const userKey = specialtyToKey(selectedSpecialty);
  return <motion.div initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="fixed top-6 right-6 z-50 bg-white/90 backdrop-blur-md rounded-2xl shadow-lg shadow-black/5 border border-neutral-100 p-2 flex items-center gap-1.5" data-id="element-256">
      <span className="text-xs font-bold text-neutral-400 uppercase tracking-wider px-2 hidden md:block" data-id="element-257">
        Compare
      </span>
      {ALL_SPECIALTIES.map(spec => {
      const isVisible = visibleSpecialties.includes(spec.key);
      const isUser = spec.key === userKey;
      const Icon = spec.icon;
      return <button key={spec.key} onClick={() => {
        if (!isUser) onToggleSpecialty(spec.key);
      }} disabled={isUser} className={`relative flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-bold transition-all ${isVisible ? 'text-white shadow-sm' : 'text-neutral-400 hover:text-neutral-700 hover:bg-neutral-100'} ${isUser ? 'cursor-default' : 'cursor-pointer'}`} style={isVisible ? {
        backgroundColor: spec.color
      } : undefined} title={isUser ? 'Your specialty (always shown)' : `${isVisible ? 'Remove' : 'Add'} ${spec.key}`} data-id="element-258">
            <Icon className="w-3.5 h-3.5" data-id="element-259" />
            <span className="hidden sm:inline" data-id="element-260">{spec.label}</span>
            {!isUser && <span className="w-3.5 h-3.5 flex items-center justify-center" data-id="element-261">
                {isVisible ? <XIcon className="w-3 h-3" data-id="element-262" /> : <PlusIcon className="w-3 h-3" data-id="element-263" />}
              </span>}
          </button>;
    })}
    </motion.div>;
}